<template>
  <div class="h-84">
    <div v-for="(skill,index) in feSkills" :key="index">
      <skill
        :img-location="skill.img_location"
        :year-experience="skill.year_experience"
        :rating="skill.rating"
        :heading="skill.heading"
      />
    </div>
    <div
      class="mt-16 text-sm text-center font-semibold text-gray-800 text-opacity-50 tracking-wider font-mono"
    >Have experience setting up web servers and configuring sites</div>
  </div>
</template>
<script>
import Skill from "../widget/Skill";
export default {
  components: {
    Skill
  },
  data() {
    return {
      feSkills: [
        {
          heading: "Nginx",
          img_location: "/img/nginx.png",
          year_experience: 1,
          rating: 6.0
        },
        {
          heading: "Ubuntu",
          img_location: "/img/ubuntu.png",
          year_experience: 1,
          rating: 6.0
        }
      ]
    };
  }
};
</script>